import Vue from 'vue'
import PopBox from './PopBox.vue'

let currentMsg, instance
let msgQueue = []

const PromptBoxConstructor = Vue.extend(PopBox)

const initObj = {
  message: null,
  type: null,
  btnList: [],
  icon: {
    show: false
  }
}

function initInstance () {
  instance = new PromptBoxConstructor({
    el: document.createElement('div')
  })

  instance.callback = (val) => {
    if (currentMsg) {
      currentMsg['resolve'](val)
    }
  }
}

function showNextMsg () {
  if (!instance) { // 实例还未初始化
    initInstance()
  }
  instance.action = ''

  if (msgQueue.length > 0) {
    currentMsg = msgQueue.shift()
    let options = Object.assign({}, initObj, currentMsg.options)

    for (let key in options) {
      if (options.hasOwnProperty(key)) {
        instance[key] = options[key]
      }
    }

    document.querySelector('#app').appendChild(instance.$el)
  }
}

function Pop (options) {
  return new Promise((resolve, reject) => {
    msgQueue.push({
      options: options,
      resolve: resolve,
      reject: reject
    })

    showNextMsg()
  })
}

function check (arr) { // 参数检查
  return arr.every(item => typeof item === 'string' && item.length > 0)
}

function alert ({ message = '', icon = { show: false } }) {
  if (check([message])) {
    return Pop({
      type: 'alert',
      message,
      icon
    })
  } else {
    console.log({
      message
    })
    throw new Error('函数参数传递错误')
  }
}

function tip ({ message = '', icon = { show: false } }) {
  if (check([message])) {
    return Pop({
      type: 'tip',
      message,
      icon
    })
  } else {
    console.log({
      message
    })
    throw new Error('函数参数传递错误')
  }
}

function confirm ({ message, btnList }) {
  if (check([message])) {
    return Pop({
      type: 'confirm',
      message,
      btnList
    })
  } else {
    console.log({
      message
    })
    throw new Error('函数参数传递错误')
  }
}

export {
  tip,
  alert,
  confirm
}



// WEBPACK FOOTER //
// ./src/mixin/pop/index.js